export const createGameClientConfigSlice = (props)=>(set, get)=>({
            gameClientConfig: {
                currentUserId: props.currentUserId,
                isBotGame: props.isBotGame,
                isAppInBackground: false,
                setIsAppInBackground: (isAppInBackground)=>set({
                        gameClientConfig: {
                            ...get().gameClientConfig,
                            isAppInBackground: isAppInBackground
                        }
                    }),
                gameOrientation: props.gameOrientation,
                enableRotateDeviceWarning: props.enableRotateDeviceWarning,
                shouldHideFullScreenButton: props.shouldHideFullScreenButton,
                requestFullScreenPermission: props.requestFullScreenPermission,
                shouldHideStoreFeatures: props.shouldHideStoreFeatures,
                shouldUseDiscordProxyForLocationFlag: props.shouldUseDiscordProxyForLocationFlag,
                shouldHideAllSendGiftOption: props.shouldHideAllSendGiftOption,
                canSendGiftAfterGameEnd: props.canSendGiftAfterGameEnd,
                hideMuteUserOption: props.hideMuteUserOption,
                shouldShowEndGameAd: props.shouldShowEndGameAd,
                friendUsernames: props.friendUsernames,
                safeAreaInsetTop: props.safeAreaInsetTop,
                safeAreaInsetBottom: props.safeAreaInsetBottom,
                shouldExcludeStoreAdContent: props.shouldExcludeStoreAdContent,
                onClickGameEndAd: props.onClickGameEndAd,
                onClickMembershipIcon: props.onClickMembershipIcon,
                onClickSendGift: props.onClickSendGift,
                onClickAddFriend: props.onClickAddFriend,
                onClickViewProfile: props.onClickViewProfile,
                onClickReportPlayer: props.onClickReportPlayer,
                onToggleMutePlayer: props.onToggleMutePlayer,
                onVolumeChanged: props.onVolumeChanged,
                onToggledMuteVolume: props.onToggledMuteVolume,
                onShowRulebook: props.onShowRulebook,
                robberSkinIcon: props.robberSkinIcon,
                goToLeaderboard: props.goToLeaderboard
            }
        });
